export default function actionTypeInCollection (actionType, actions) {
  const allLeafNodes = getAllLeafNodes(actions)
  return allLeafNodes.includes(actionType ? actionType.toLowerCase() : '')
}

function getAllLeafNodes (obj) {
  if (typeof obj === 'string') {
    return [obj.toLowerCase()]
  }
  if (Array.isArray(obj)) {
    return obj.flatMap(item => getAllLeafNodes(item))
  }
  if (obj && typeof obj === 'object') {
    let results = []
    Object.keys(obj).forEach(key => {
      const value = obj[key]
      results = results.concat(getAllLeafNodes(value))
    })
    return results
  }

  return []
}